import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";

import LoadingSpinner from "shared/components/UIElements/LoadingSpinner";

import { AuthContext } from "shared/context/auth-context";
import { StoreContext } from "shared/context/store-context";

const CheckAccess = (props) => {
  const auth = useContext(AuthContext);
  const store = useContext(StoreContext);

  if (!store.storeReady) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  } else if (props?.access) {
    // Check if access is an array or single value
    const permissions = Array.isArray(props.access) ? props.access : [props.access];

    // Check if user has access to at least one of the permissions
    const hasAccess = permissions.some((permission) => auth.permissions[permission]);

    if (!hasAccess) {
      return <Navigate to="/not-found" replace />;
    }
  }

  return <Outlet />;
};

export default CheckAccess;
